var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkbox",class:_vm.classes},[_c('span',{staticClass:"icon-button",style:({
      width: _vm.computedCheckboxSize,
      height: _vm.computedCheckboxSize,
      background: _vm.computedBackgroundColor,
    }),on:{"click":_vm.handleCheck,"mouseenter":_vm.handleHoverEnter,"mouseleave":_vm.handleHoverLeave}},[_c('svg',{staticClass:"icon",style:({
        width: _vm.computedIconSize,
        height: _vm.computedIconSize,
        fill: _vm.computedIconFillColor,
      }),attrs:{"focusable":"false","viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":_vm.computedPath}})])]),_c('span',{staticClass:"label-placeholder",style:({ color: _vm.computedLabelColor }),on:{"click":_vm.handleCheck}},[_vm._v(_vm._s(this.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }